import { MailingAddressUpdate } from '../../components/organisms/MailingAddressLookUpUpdate'

const MailingAddressUpdateScreen = props => <MailingAddressUpdate {...props} />

export default MailingAddressUpdateScreen